import React, { Component, Suspense } from 'react';
import Layout from './components/Layout/';
import { Route, Switch, BrowserRouter as Router, withRouter } from 'react-router-dom';

// Import Css
import './Apps.scss';
import './css/materialdesignicons.min.css';
import './css/colors/default.css';

// Include Routes 
import routes from './routes';
import routesProfx from './routes_affiliate_profx';
import routesMMT from './routes_affiliate_mmt';
import routesAffiliate from './routes_affiliate';

function withLayout(WrappedComponent) {
  // ...and returns another component...
  return class extends React.Component {  
    render() {
      return <Layout>
        <WrappedComponent></WrappedComponent>
      </Layout>
    }
  };
}

class App extends Component {

  Loader = () => {
    return (
      <div id="preloader">
          <div id="status">
              <div className="spinner">
                  <div className="double-bounce1"></div>
                  <div className="double-bounce2"></div>
              </div>
          </div>
      </div>
    );
}
  render() {

    // If we get more than 3 parts, then we have a subdomain
    // INFO: This could be 4, if you have a co.uk TLD or something like that.
    
    let host = window.location.host;
    let parts = host.split(".");
    let subdomain = (parts[0] === "www") ?  parts[1] :  parts[0];

    return (
      <React.Fragment>  
      <Router>
        <Suspense fallback = {this.Loader()} >
            <Switch>
            {
              (subdomain === "profx") ? 
              routesProfx.map((route, idx) =>
              route.isWithoutLayout ?
                <Route path={route.path} component={route.component} key={idx} />
              :
                <Route path={route.path} component={withLayout(route.component)} key={idx} />
              )
              :
              (subdomain === "mmt") ? 
              routesMMT.map((route, idx) =>
              route.isWithoutLayout ?
                <Route path={route.path} component={route.component} key={idx} />
              :
                <Route path={route.path} component={withLayout(route.component)} key={idx} />
              )
              : (subdomain === "affiliate") ? 
              routesAffiliate.map((route, idx) =>
              route.isWithoutLayout ?
                <Route path={route.path} component={route.component} key={idx} />
              :
                <Route path={route.path} component={withLayout(route.component)} key={idx} />
              )
              :routes.map((route, idx) =>
                route.isWithoutLayout ?
                  <Route path={route.path} component={route.component} key={idx} />
                :
                  <Route path={route.path} component={withLayout(route.component)} key={idx} />
              )
            }
            </Switch>
            </Suspense>
        </Router>
      </React.Fragment>
    );
  }
}

export default withRouter(App);